/**
 * Form for submitting a request to resend the email verfication email
 */
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, SubmissionError } from 'redux-form';
import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';

import BusyButton from 'components/BusyButton/BusyButton';

/**
 * Appropriate throw an error with the relevant validation errors if necessary
 *
 * @param {result} value - Result of the form submission
 * @throws {error} - Throws SubmissionError if any errors were returned
 */
const handleFormSubmissionReturn = (result) => {
  if (result.error) {
    throw new SubmissionError(result.formErrors);
  }
};

const propTypes = {
  classes: PropTypes.shape({
    status: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
  error: PropTypes.string,
  handleSendEmailVerification: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const defaultProps = {
  error: null,
};

export function UnstyledVerifyEmailForm({
  classes,
  error,
  handleSendEmailVerification,
  handleSubmit,
  submitSucceeded,
  submitting,
}) {
  const submitHandler = () => handleSendEmailVerification().then(handleFormSubmissionReturn);

  const errorElm = error ? (
    <Typography color="error" className={classes.status}>
      {error}
    </Typography>
  ) : null;

  const successElm = submitSucceeded ? (
    <Typography color="secondary" className={classes.status}>
      Verification email resent! Please check your email.
    </Typography>
  ) : null;

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <BusyButton
        type="submit"
        variant="contained"
        color="primary"
        loading={submitting}
        disabled={submitSucceeded}
        className={classes.button}
      >
        Resend Email
      </BusyButton>
      {errorElm}
      {successElm}
    </form>
  );
}

UnstyledVerifyEmailForm.defaultProps = defaultProps;
UnstyledVerifyEmailForm.propTypes = propTypes;

const styles = () => ({
  button: {
    marginTop: '.5rem',
  },
  status: {
    marginTop: '.5rem',
  },
});

export default withStyles(styles)(
  reduxForm({
    form: 'resendEmailVerification',
  })(UnstyledVerifyEmailForm),
);
